__turbopack_export_value__({
  "body-logo-18": "ControlledCheckbox-module-scss-module__oKto4q__body-logo-18",
  "body-text-12": "ControlledCheckbox-module-scss-module__oKto4q__body-text-12",
  "body-text-14": "ControlledCheckbox-module-scss-module__oKto4q__body-text-14",
  "body-text-16": "ControlledCheckbox-module-scss-module__oKto4q__body-text-16",
  "body-text-18": "ControlledCheckbox-module-scss-module__oKto4q__body-text-18",
  "body-text-20": "ControlledCheckbox-module-scss-module__oKto4q__body-text-20",
  "body-text-24": "ControlledCheckbox-module-scss-module__oKto4q__body-text-24",
  "body-text-24-2": "ControlledCheckbox-module-scss-module__oKto4q__body-text-24-2",
  "body-text-heading-2": "ControlledCheckbox-module-scss-module__oKto4q__body-text-heading-2",
  "body-text-heading-3": "ControlledCheckbox-module-scss-module__oKto4q__body-text-heading-3",
  "body-text-medium-14": "ControlledCheckbox-module-scss-module__oKto4q__body-text-medium-14",
  "body-text-medium-16": "ControlledCheckbox-module-scss-module__oKto4q__body-text-medium-16",
  "body-text-medium-18": "ControlledCheckbox-module-scss-module__oKto4q__body-text-medium-18",
  "body-text-medium2-18": "ControlledCheckbox-module-scss-module__oKto4q__body-text-medium2-18",
  "body-text2-14": "ControlledCheckbox-module-scss-module__oKto4q__body-text2-14",
  "body-text2-16": "ControlledCheckbox-module-scss-module__oKto4q__body-text2-16",
  "button-primary-text": "ControlledCheckbox-module-scss-module__oKto4q__button-primary-text",
  "button-text": "ControlledCheckbox-module-scss-module__oKto4q__button-text",
  "button2-text": "ControlledCheckbox-module-scss-module__oKto4q__button2-text",
  "card-shadow": "ControlledCheckbox-module-scss-module__oKto4q__card-shadow",
  "checkbox__error": "ControlledCheckbox-module-scss-module__oKto4q__checkbox__error",
  "checkbox__error_visible": "ControlledCheckbox-module-scss-module__oKto4q__checkbox__error_visible",
  "checkbox__inner": "ControlledCheckbox-module-scss-module__oKto4q__checkbox__inner",
  "checkbox__mark": "ControlledCheckbox-module-scss-module__oKto4q__checkbox__mark",
  "checkbox__mark_checked": "ControlledCheckbox-module-scss-module__oKto4q__checkbox__mark_checked",
  "checkbox__text": "ControlledCheckbox-module-scss-module__oKto4q__checkbox__text",
  "effect-menu": "ControlledCheckbox-module-scss-module__oKto4q__effect-menu",
  "header-1": "ControlledCheckbox-module-scss-module__oKto4q__header-1",
  "main-container": "ControlledCheckbox-module-scss-module__oKto4q__main-container",
  "main-footer-container": "ControlledCheckbox-module-scss-module__oKto4q__main-footer-container",
  "main-header-container": "ControlledCheckbox-module-scss-module__oKto4q__main-header-container",
  "txt-12-bold": "ControlledCheckbox-module-scss-module__oKto4q__txt-12-bold",
  "txt-14-bold": "ControlledCheckbox-module-scss-module__oKto4q__txt-14-bold",
  "txt-14-bold-caps": "ControlledCheckbox-module-scss-module__oKto4q__txt-14-bold-caps",
  "txt-14-med": "ControlledCheckbox-module-scss-module__oKto4q__txt-14-med",
  "txt-16-bold": "ControlledCheckbox-module-scss-module__oKto4q__txt-16-bold",
  "txt-16-med": "ControlledCheckbox-module-scss-module__oKto4q__txt-16-med",
  "txt-18-bold": "ControlledCheckbox-module-scss-module__oKto4q__txt-18-bold",
  "txt-18-medium": "ControlledCheckbox-module-scss-module__oKto4q__txt-18-medium",
  "txt-18-medium-24": "ControlledCheckbox-module-scss-module__oKto4q__txt-18-medium-24",
  "txt-24-semi": "ControlledCheckbox-module-scss-module__oKto4q__txt-24-semi",
});
